import {
  APP_LOADED,
  SEARCH_OPTION_SELECTED,
  UPDATE_QUERY,
  ADD_FILTER,
  REMOVE_FILTER,
  RESET_FILTER,
  RESET_FILTERS,
  RESTORE_FILTERS,
  UPDATE_FILTER,
  UPDATE_FILTERS,
  UPDATE_SORT,
  UPDATE_PAGE,
  RESET_PAGE,
  UPDATE_SETTINGS,
  UPDATE_SEARCH_RESULTS_PAGE,
} from "./actionTypes";

const initialState = {
  query: {
    filters: [],
    page: 1,
    searchResultsPage: 1,
    sortBy: null,
  },
};

export const search = (state = initialState, action) => {
  if (action.type === APP_LOADED) {
    return {
      ...state,
      initialQuery: action.payload.query,
      simpleUrlParams: action.payload.simpleUrlParams,
      route: action.payload.route,
    };
  } else if (action.type === SEARCH_OPTION_SELECTED) {
    return {
      ...state,
      searchOption: action.payload,
    };
  } else if (action.type === UPDATE_QUERY) {
    return {
      ...state,
      query: action.payload,
    };
  } else if (action.type === UPDATE_SETTINGS) {
    return {
      ...state,
      settings: action.payload,
    };
  } else if (action.type === ADD_FILTER) {
    const current = state.query.filters;
    const newFilters = current.concat(action.payload);
    return updateFilters(state, newFilters);
  } else if (action.type === REMOVE_FILTER) {
    const current = state.query.filters;
    const newFilters = current.filter(f => !isEqual(f, action.payload));
    return updateFilters(state, newFilters);
  } else if (action.type === UPDATE_FILTER) {
    const current = state.query.filters;
    const newFilters = removeByKeys(current, [action.payload]).concat(
      action.payload.value ? action.payload : [],
    );

    newFilters.forEach((item)=> {
      Object.keys(item).forEach(function(key) {
        if ( item[key] && item[key] !== 'type' && (typeof item[key] === 'string' || item[key] instanceof String)) {
          item[key] = item[key].replaceAll('%20','-').replaceAll(' ',"-");
        }
      })
    });

    return updateFilters(state, newFilters);
  } else if (action.type === UPDATE_FILTERS) {
    const current = state.query.filters;

    const newFilters = removeByKeys(current, action.payload).concat(action.payload);

    return updateFilters(state, newFilters);
  } else if (action.type === RESET_FILTER) {
    const filter = { key: action.payload };

    const newFilters = removeByKeys(state.query.filters, [filter]);

    return updateFilters(state, newFilters);
  } else if (action.type === RESET_FILTERS) {
    const newFilters = [];
    const query = state.query;

    const noFilters = updateFilters(state, newFilters);
    const newState = updatePage(noFilters, 1);

    return {
      ...newState,
      savedQuery: {
        type: state.searchOption,
        query: query,
      },
    };
  } else if (action.type === RESTORE_FILTERS) {
    const { savedQuery, ...newState } = state;

    return {
      ...newState,
      query: savedQuery.query,
    };
  } else if (action.type === UPDATE_SORT) {
    return updateSort(state, action.payload);

  }
  else if(action.type === UPDATE_PAGE){
      const page = action.payload || 1;
      return updatePage(state, page);
  }
  else if(action.type === RESET_PAGE){
    const page = 1;
    return updatePage(state, page);
  }
  else if(action.type === UPDATE_SEARCH_RESULTS_PAGE) {
    const searchResultsPage = action.payload || 1;
    return {
      ...state,
      query: { ...state.query, searchResultsPage },
    }
  }
  return state;
};

const isKeyEqual = (f1, f2) => f1.key === f2.key;

const isEqual = (f1, f2) => isKeyEqual(f1, f2) &&
  (f1.value === f2.value || f1.value.toLowerCase() === f2.value.toLowerCase());

const updateQuery = (state, key, value) => {
  const { savedQuery, ...newState } = state;

  return {
    ...newState,
    query: {
      ...state.query,
      [key]: value,
    },
  };
};

const updateFilters = (state, filters) => updateQuery(state, "filters", filters);

const updatePage = (state, page) => updateQuery(state, "page", page);

const updateSort = (state, sortBy) => updateQuery(state, "sortBy", sortBy);

const removeByKeys = (filters, toRemove) =>
  filters.filter(f1 => !toRemove.some(f2 => isKeyEqual(f1, f2)));
